import gql from 'graphql-tag';

export const EnableSuperAdmin = gql`
	mutation EnableSuperAdmin {
		enableSuperAdmin {
			user {
				id
				confluence {
					roles {
						isSuperAdmin
					}
				}
			}
		}
	}
`;
